var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFi681494(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_152_4407)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5358 12.8119H18.6797C18.8689 13.3299 18.9722 13.8888 18.9722 14.4715V21.4863C18.9722 21.7292 18.93 21.9624 18.853 22.1792H21.9215C23.0678 22.1792 24.0002 21.2467 24.0002 20.1005V16.2764C24.0003 14.3661 22.4461 12.8119 20.5358 12.8119Z",
    fill: "#5158E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.02806 14.4715C5.02806 13.8889 5.13142 13.3299 5.3206 12.812H3.46454C1.55419 12.812 0 14.3661 0 16.2765V20.1006C0 21.2468 0.932486 22.1793 2.07872 22.1793H5.14726C5.07034 21.9624 5.02806 21.7293 5.02806 21.4864V14.4715Z",
    fill: "#5158E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1218 11.007H9.8786C7.96825 11.007 6.41406 12.5611 6.41406 14.4715V21.4864C6.41406 21.869 6.72428 22.1793 7.10697 22.1793H16.8935C17.2761 22.1793 17.5864 21.869 17.5864 21.4864V14.4715C17.5864 12.5611 16.0322 11.007 14.1218 11.007Z",
    fill: "#5158E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9995 1.82062C9.70211 1.82062 7.83301 3.68971 7.83301 5.9872C7.83301 7.54557 8.69312 8.90658 9.96334 9.62115C10.5658 9.96006 11.2604 10.1537 11.9995 10.1537C12.7387 10.1537 13.4333 9.96006 14.0358 9.62115C15.306 8.90658 16.1661 7.54552 16.1661 5.9872C16.1661 3.68976 14.297 1.82062 11.9995 1.82062Z",
    fill: "#5158E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.6834 5.70422C2.9652 5.70422 1.56738 7.10204 1.56738 8.82025C1.56738 10.5385 2.9652 11.9363 4.6834 11.9363C5.11925 11.9363 5.53428 11.846 5.9113 11.6837C6.56314 11.4031 7.10061 10.9063 7.43319 10.284C7.66663 9.84728 7.79943 9.34904 7.79943 8.82025C7.79943 7.10209 6.40161 5.70422 4.6834 5.70422Z",
    fill: "#5158E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3162 5.70416C17.598 5.70416 16.2002 7.10198 16.2002 8.82018C16.2002 9.34903 16.333 9.84726 16.5664 10.284C16.899 10.9063 17.4365 11.403 18.0883 11.6836C18.4653 11.8459 18.8804 11.9362 19.3162 11.9362C21.0344 11.9362 22.4322 10.5384 22.4322 8.82018C22.4322 7.10198 21.0344 5.70416 19.3162 5.70416Z",
    fill: "#5158E8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_152_4407"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFi681494);
export default __webpack_public_path__ + "static/media/fi_681494.d6140e6f2c54dc96fa36188b0eba5f5a.svg";
export { ForwardRef as ReactComponent };